import * as React from "react";
import {Glyphicon, Row} from "react-bootstrap";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";
import {connect} from "react-redux";

class ModalMensajeRechazo extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    render() {
        return (
            <div>
                <Row>
                    <a title={"Ver mensaje"} className={"btns btns-primary"}
                       onClick={() => this.handleShow()}><Glyphicon glyph={"info-sign"}/></a>
                </Row>
                <Row>
                    <ModalConfirmacion titulo={"Documentos aprobados"} show={this.state.show}
                                       onCancelar={() => this.handleClose()}>
                                       Su solicitud fue rechazada.
                    </ModalConfirmacion>
                </Row>
            </div>
        );
    }

}

export default connect((store: any, props: any) => {
    return {
        ...props
    };
})(ModalMensajeRechazo);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/ModalMensajeRechazo.tsx